import styled from 'styled-components'
import { limitLines } from 'src/styles'

const defaultHeight = '5.375rem' // 86px

type WrapperProps = {
  $loading?: boolean
}

export const Wrapper = styled.a<WrapperProps>`
  background-color: var(--gray-100);
  color: var(--gray-900);
  height: ${defaultHeight};
  transition: 0.2s background-color;
  cursor: ${({ $loading }) => ($loading ? 'default' : 'pointer')};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--gray-200);
  border-radius: var(--border-radius-lg);
  overflow: hidden;
  text-decoration: none;

  &:hover {
    background-color: ${({ $loading }) => ($loading ? 'inherit' : 'var(--gray-200)')};
    color: var(--gray-900);
  }
`

Wrapper.displayName = 'Wrapper'

export const ImageWrapper = styled.div`
  width: ${defaultHeight};
  height: ${defaultHeight};

  img {
    object-fit: cover;
  }
`

ImageWrapper.displayName = 'ImageWrapper'

export const TextWrapper = styled.div``

TextWrapper.displayName = 'TextWrapper'

export const Title = styled.h2`
  ${limitLines(2)}
`

Title.displayName = 'Title'

export const Url = styled.span`
  ${limitLines(1)}
`

Url.displayName = 'Url'
